import Input from "components/atoms/input/Input";
import { postAlertSendEmail } from "api/alertAPI";
import { ModalInput } from "components/atoms/input/modal/ModalInput";
import SmallPopupTemplate from "components/templates/modal/small/SmallPopupTemplate";
import { useCallback, useState } from "react";
import { useMutation } from "react-query";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import useApiError from "hook/useApiError";
import { CustomError } from "api/interfaces/commonInterface.interface";
import { AssigneeInfo } from "api/interfaces/dashboardInterface.interface";
import TextArea from "components/atoms/input/TextArea";

type SendEmailModalType = {
  assignee: AssigneeInfo;
  recorderId: string;
  onModal: () => void;
};

export const SendEmailModal = ({
  assignee,
  recorderId,
  onModal,
}: SendEmailModalType) => {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const { handleErrorNotify, notifySuccess, lang } = useApiError();
  const [message, setMessage] = useState<string>("");
  const [error, setError] = useState({
    status: false,
    msg: "",
  });

  const mutationSendAlertEmail = useMutation(postAlertSendEmail, {
    onSuccess: () => {
      notifySuccess(lang.label.common.notify.email.success);
      onModal();
    },
    onError: (err: CustomError) => {
      handleErrorNotify(err, lang.ServerErrorCode[121014]);
    },
  });

  const onClickSendEmail = useCallback(() => {
    if (!assignee || !assignee.assigneeEmail) {
      return;
    }
    setError({
      status: false,
      msg: "",
    });
    mutationSendAlertEmail.mutate({
      accountId: selectedAccount.accountId,
      recorderId: recorderId,
      payload: {
        email: assignee.assigneeEmail,
        message: message,
      },
    });
  }, [selectedAccount.accountId, recorderId, assignee, message]);

  return (
    <SmallPopupTemplate
      cancel
      title="Send an Email"
      subTitle="Send an email to your technician"
      onClick={onClickSendEmail}
      onModal={onModal}
      confirmLabel="Send"
      className="full-width"
      data-testid="dashboard-map-list-info-item-small-popup-template-click-send-email"
    >
      <ModalInput label="Email" essential>
        <Input
          placeholder="Please enter an email"
          disabled={true}
          defaultValue={assignee.assigneeEmail}
        />
      </ModalInput>
      <ModalInput
        label="Message (Optional)"
        isValidated={error.status}
        validatedWord={error.msg}
      >
        <TextArea
          placeholder="Enter your message here"
          value={message}
          onChange={(e) => {
            setMessage(e.target.value);
          }}
          data-testid="dashboard-map-list-info-item-textarea-set-message"
        />
      </ModalInput>
    </SmallPopupTemplate>
  );
};
